import React, { useState } from 'react'
import { api } from '../../../../../utils'
import {
  EDITDATIAZIENDA,
  EDITDATIUTENTE,
  PROFILOAZIENDACHECKPIVA,
} from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import useTrans from '../../../../../hooks/useTrans'
import { useSelector } from 'react-redux'
import { getMissingRequiredFields } from '../../../../../utils/servicegift'
import FormInput from '../../../../atoms/FormInput/FormInput'
import MyAccountForm from '../../../../molecules/MyAccountForm/MyAccountForm'
import { Form, Formik } from 'formik'
import { getValidationSchema } from './validationSchema'

const InfoGenerali = ({ props, step, setStep, carrello_main, Submit }) => {
  const t = useTrans()
  const { utente } = useSelector((state) => state?.utente)
  const { service_gift } = useSelector((state) => state?.servicegift)
  const sgMissingFields = getMissingRequiredFields(service_gift, utente, 'checkout')

  const utenteFields = sgMissingFields.filter((x) => x.includes('utente.')) || []
  const aziendaFields = sgMissingFields.filter((x) => x.includes('anagrafica_azienda.')) || []

  const [pivaExists, setPivaExists] = useState(false)

  const validationSchema = getValidationSchema(utente?.tipologia)

  const initialValues = {
    utente: {
      telefono: props?.values?.utente?.telefono,
    },
    anagrafica_azienda: {
      ragione_sociale: props?.values?.utente?.anagrafica_azienda.ragione_sociale,
      partita_iva: props?.values?.utente?.anagrafica_azienda.partita_iva,
      cod_fiscale: props?.values?.utente?.anagrafica_azienda.cod_fiscale,
      email: props?.values?.utente?.anagrafica_azienda.email,
      telefono: props?.values?.utente?.anagrafica_azienda.telefono,
    },
  }

  const handleSaveDatiUtente = async (values) => {
    return api.post(EDITDATIUTENTE, { ...values.utente }).catch((error) => console.log(error))
  }

  const handleSaveDatiAzienda = async (values) => {
    return api
      .post(EDITDATIAZIENDA, { ...values.anagrafica_azienda })
      .catch((error) => console.log(error))
  }

  const handleSaveDati = async (values) => {
    await handleSaveDatiAzienda(values)
    await handleSaveDatiUtente(values)
    Object.keys(values?.utente).forEach((chiave) => {
      props.setFieldValue(`utente.${chiave}`, values.utente?.[chiave])
    })
    Object.keys(values?.anagrafica_azienda).forEach((chiave) => {
      props.setFieldValue(
        `utente.anagrafica_azienda.${chiave}`,
        values.anagrafica_azienda?.[chiave]
      )
    })
  }

  return (
    <div
      className={`checkout__info-generali ${
        service_gift ? 'checkout__info-generali--servicegift' : ''
      }`}
    >
      <div className="checkout__section">
        <p className="checkout__section-subtitle">
          {t("Per completare l'acquisto abbiamo bisogno delle seguenti informazioni mancanti.")}
        </p>
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          if (aziendaFields.includes('anagrafica_azienda.partita_iva')) {
            const params = { partita_iva: values.anagrafica_azienda.partita_iva }
            api
              .get(PROFILOAZIENDACHECKPIVA, { params })
              .then(async (response) => {
                if (
                  response.data.exists &&
                  values.anagrafica_azienda !== initialValues.anagrafica_azienda.partita_iva
                ) {
                  setPivaExists(true)
                } else {
                  handleSaveDati(values)
                  setStep(step + 1)
                }
              })
              .catch((error) => console.log(error))
              .finally(() => setSubmitting(false))
          } else {
            handleSaveDati(values)
            setStep(step + 1)
          }
        }}
      >
        {(props) => (
          <Form>
            <MyAccountForm>
              {utenteFields?.length > 0 && (
                <div>
                  <p className="checkout__section-title">{t('Informazioni personali')}</p>
                  {utenteFields.includes('utente.telefono') && (
                    <FormField
                      label={t('telefono') + (utenteFields.includes('utente.telefono') ? ' *' : '')}
                      status={
                        props.touched.utente?.telefono && props.errors.utente?.telefono
                          ? 'error'
                          : props.touched.utente?.telefono && 'success'
                      }
                      errorMessage={props.errors?.utente?.telefono}
                      infoMessage={t('Inserisci il numero di telefono con il prefisso nazionale')}
                    >
                      <FormInput
                        value={props.values.utente?.telefono}
                        placeholder={t('Inserisci il numero di cellulare')}
                        onBlur={props.handleBlur('utente.telefono')}
                        onChange={props.handleChange('utente.telefono')}
                      ></FormInput>
                    </FormField>
                  )}
                </div>
              )}
            </MyAccountForm>

            <MyAccountForm>
              {aziendaFields?.length > 0 && (
                <div>
                  <p className="checkout__section-title">{t('Informazioni aziendali')}</p>

                  {aziendaFields.includes('anagrafica_azienda.email') && (
                    <FormField
                      label={
                        t('E-mail') +
                        (aziendaFields.includes('anagrafica_azienda.email') ? ' *' : '')
                      }
                      status={
                        props.touched.anagrafica_azienda?.email &&
                        props.errors.anagrafica_azienda?.email
                          ? 'error'
                          : props.touched.anagrafica_azienda?.email && 'success'
                      }
                      errorMessage={props.errors?.anagrafica_azienda?.email}
                    >
                      <FormInput
                        placeholder={t('Inserisci la mail')}
                        value={props.values.anagrafica_azienda?.email}
                        onBlur={props.handleBlur('anagrafica_azienda.email')}
                        onChange={props.handleChange('anagrafica_azienda.email')}
                      ></FormInput>
                    </FormField>
                  )}

                  {aziendaFields.includes('anagrafica_azienda.ragione_sociale') && (
                    <FormField
                      label={
                        t('Ragione Sociale') +
                        (aziendaFields.includes('anagrafica_azienda.ragione_sociale') ? ' *' : '')
                      }
                      status={
                        props.touched.anagrafica_azienda?.ragione_sociale &&
                        props.errors.anagrafica_azienda?.ragione_sociale
                          ? 'error'
                          : props.touched.anagrafica_azienda?.ragione_sociale && 'success'
                      }
                      errorMessage={props.errors?.anagrafica_azienda?.ragione_sociale}
                    >
                      <FormInput
                        placeholder={t('Inserisci la ragione sociale')}
                        value={props.values.anagrafica_azienda?.ragione_sociale}
                        onChange={props.handleChange('anagrafica_azienda.ragione_sociale')}
                        onBlur={props.handleBlur('anagrafica_azienda.ragione_sociale')}
                      ></FormInput>
                    </FormField>
                  )}

                  {aziendaFields.includes('anagrafica_azienda.partita_iva') && (
                    <FormField
                      label={
                        t('P.IVA') +
                        (aziendaFields.includes('anagrafica_azienda.partita_iva') ? ' *' : '')
                      }
                      status={
                        pivaExists
                          ? 'error'
                          : props.touched.anagrafica_azienda?.partita_iva &&
                            props.errors.anagrafica_azienda?.partita_iva
                          ? 'error'
                          : props.touched.anagrafica_azienda?.partita_iva && 'success'
                      }
                      errorMessage={
                        props.errors?.anagrafica_azienda?.partita_iva ||
                        (pivaExists && t('La partita iva inserita risulta essere già registrata'))
                      }
                      infoMessage={t('Inserisci la partita IVA senza spazi né prefisso nazionale')}
                    >
                      <FormInput
                        placeholder={t('Inserisci la p.iva')}
                        value={props.values.anagrafica_azienda?.partita_iva}
                        onChange={props.handleChange('anagrafica_azienda.partita_iva')}
                        onBlur={props.handleBlur('anagrafica_azienda.partita_iva')}
                      ></FormInput>
                    </FormField>
                  )}

                  {aziendaFields.includes('anagrafica_azienda.cod_fiscale') && (
                    <FormField
                      label={
                        t('Codice fiscale') +
                        (aziendaFields.includes('anagrafica_azienda.cod_fiscale') ? ' *' : '')
                      }
                      status={
                        props.touched.anagrafica_azienda?.cod_fiscale &&
                        props.errors.anagrafica_azienda?.cod_fiscale
                          ? 'error'
                          : props.touched.anagrafica_azienda?.cod_fiscale && 'success'
                      }
                      errorMessage={props.errors?.anagrafica_azienda?.cod_fiscale}
                    >
                      <FormInput
                        placeholder={t('Inserisci il codice fiscale')}
                        value={props.values.anagrafica_azienda?.cod_fiscale}
                        onBlur={props.handleBlur('anagrafica_azienda.cod_fiscale')}
                        onChange={props.handleChange('anagrafica_azienda.cod_fiscale')}
                      ></FormInput>
                    </FormField>
                  )}

                  {aziendaFields.includes('anagrafica_azienda.telefono') && (
                    <FormField
                      label={
                        t('telefono') +
                        (aziendaFields.includes('anagrafica_azienda.telefono') ? ' *' : '')
                      }
                      status={
                        props.touched.anagrafica_azienda?.telefono &&
                        props.errors.anagrafica_azienda?.telefono
                          ? 'error'
                          : props.touched.anagrafica_azienda?.telefono && 'success'
                      }
                      errorMessage={props.errors?.anagrafica_azienda?.telefono}
                    >
                      <FormInput
                        placeholder={t('Inserisci il numero di telefono')}
                        value={props.values.anagrafica_azienda?.telefono}
                        onBlur={props.handleBlur('anagrafica_azienda.telefono')}
                        onChange={props.handleChange('anagrafica_azienda.telefono')}
                      ></FormInput>
                    </FormField>
                  )}
                </div>
              )}
            </MyAccountForm>

            <Button
              label="Conferma dati"
              size="medium"
              variant="primary"
              disabled={props.isSubmitting || !props.isValid}
              onClick={() => props.handleSubmit()}
              className="checkout__conferma-button"
            />
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default InfoGenerali
